import { Component, Inject, Optional, ViewChild, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UsuariosService } from '@services/usuarios/usuarios.service';
import { RegioncomunaService } from '@services/regioncomuna/regioncomuna.service';
import { UnidadesService } from '@services/unidades/unidades.service';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import { UsuarioData } from 'src/app/common/interfaces/user-login.interface';
import { Comuna, DireccionRegional } from 'src/app/common/interfaces/region-comuna.interface';
import { PerfilUsuario } from 'src/app/common/interfaces/perfil-usuario.interface';
import { UnidadGroup } from 'src/app/common/interfaces/unidad.interface';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { FormBuilder, FormControl } from '@angular/forms';
import Utils from '@utils/utils';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { CargoGroup } from 'src/app/common/interfaces/cargo.interface';
import { ToolsService } from '@services/varios/tools.service';
import { LOGINS } from '@env/environment';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Perfil } from 'src/app/common/interfaces/perfil.interface';
import { PerfilesUsuarioComponent } from './perfiles-usuario/perfiles-usuario.component';
import { AuthService } from '@services/auth/auth.service';

export const _filter = (opt: string[], value: string): string[] => {
  const filterValue = Utils.removeAccentsOfString(value).toLowerCase();
  return opt.filter((item) => Utils.removeAccentsOfString(item).toLowerCase().includes(filterValue));
};

@Component({
  selector: 'app-usuario-app',
  templateUrl: 'usuario.component.html',
})

export class UsuarioComponent implements OnInit {

  @ViewChild(MatAutocompleteTrigger) _auto!: MatAutocompleteTrigger;
  public unidadGroup = new FormControl();

  async seleccionarPerfiles(perfilesSeleccionados: any): Promise<void> {

    let perfilesTemp :PerfilUsuario[] = [];

    this.perfiles.forEach(element => {
      let perfilX: PerfilUsuario = {} as PerfilUsuario;    
      const idsLista2 = new Set(perfilesSeleccionados.map((item: { idPerfil: any; }) => item.idPerfil)); 
      perfilX.idPerfil = element.idPerfil;
      perfilX.idSistema = element.idSistema;
      perfilX.nombrePerfil = element.nombrePerfil;
      perfilX.ordenJerarquia = element.ordenJerarquia;
      perfilX.usarDatosNacionales = element.usarDatosNacionales;
      perfilX.predeterminado = this.local_data.idPerfil == element.idPerfil;
      perfilX.checked =  idsLista2.has(element.idPerfil);
      perfilesTemp.push(perfilX);
    });

    const dialogRef = this.dialogPerfilesUsuario.open(PerfilesUsuarioComponent, {
      width: '600px',
      disableClose: true,
      data: {
        perfilesSeleccionados: perfilesSeleccionados,
        perfiles: perfilesTemp
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.local_data.perfiles = result.data.perfilesSeleccionados.filter((x: { checked: any; }) => x.checked);

        if (this.local_data.perfiles.length == 1) {
          this.local_data.nombrePerfil = this.local_data.perfiles[0].nombrePerfil;
          this.local_data.idPerfil = this.local_data.perfiles[0].idPerfil;
          this.local_data.usarDatosNacionales = this.local_data.perfiles[0].usarDatosNacionales;
          this.local_data.perfiles[0].predeterminado = true;
        }
      }
    });
  }

  onClick(event: MouseEvent) {
    if (!this.isDisableUserPass) {
      if (this.password === 'password') {
        this.password = 'text';
        this.show = true;
      } else {
        this.password = 'password';
        this.show = false;
      }
    } else {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  unidadSeleccionada(arg0: any) {
    this.local_data.corrUnidadGesdep = arg0.toString().split('|')[0];
    this.local_data.unidad = arg0.toString().split('|')[1];
    this.unidadGroup.setValue(this.local_data.unidad);
  }

  password: string = 'password';
  show: boolean = false;
  isDisableUserPass: boolean = LOGINS.filter(x => x.tipo.includes('LOG_UsuarioLocal'))[0].value == '';

  action: string;
  local_data: any;
  direccionesRegionales: DireccionRegional[] = [];
  comunas: Comuna[] = [];
  comunasTodas: Comuna[] = [];
  perfiles: Perfil[] = [];
  perfilesUsuario: PerfilUsuario[] = [];

  unidadForm = this._formBuilder.group({
    unidadGroup: '',
  });

  unidadGroups: UnidadGroup[] = [];
  unidadGroupOptions: Observable<UnidadGroup[]> = new Observable<UnidadGroup[]>();

  cargoForm = this._formBuilderCargo.group({
    cargoGroup: '',
  });

  cargoGroups: CargoGroup[] = [];
  cargoGroupOptions: Observable<CargoGroup[]> = new Observable<CargoGroup[]>();

  constructor(
    private readonly spinnerService: SpinnerService,
    private readonly _formBuilder: FormBuilder,
    private readonly _formBuilderCargo: FormBuilder,
    private readonly regioncomunaService: RegioncomunaService,
    private readonly usuariosService: UsuariosService,
    private readonly unidadesService: UnidadesService,
    private readonly authService: AuthService,
    private readonly dialogPerfilesUsuario: MatDialog,
    private readonly dialogRef: MatDialogRef<UsuarioComponent>,
    public readonly toolsService: ToolsService,
    private readonly perfilesService: PerfilesService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsuarioData
  ) {
    this.local_data = { ...data };
    this.action = this.local_data.action;
  }

  validacionesLocales() {
    let mensaje: string = '';
    let dato = this.unidadGroups.findIndex((el) => {
      return el.nombresUnidad.find((z) => z == this.local_data.corrUnidadGesdep + '|' + this.local_data.unidad);
    });

    if (dato === -1) {
      mensaje += 'UNIDAD: ' + this.local_data.unidad + ' no existe (Seleccione una opcion válida de la lista)<br>';
      this.local_data.unidad = '';
    } else if (this.local_data.unidad.toString().includes(' - ')) {
      let datosC: string[] = this.local_data.unidad.toString().split(' - ');
      this.local_data.codigoUnidadGesdep = datosC[datosC.length - 1];
    } else {
      this.local_data.codigoUnidadGesdep = '0';
    }

    dato = this.cargoGroups.findIndex((elg) => {
      return elg.nombresCargo.find((z) => z == this.local_data.cargo);
    });

    if (dato === -1) {
      mensaje += 'CARGO: ' + this.local_data.cargo + ' no existe (Seleccione una opcion válida de la lista)<br>';
      this.local_data.cargo = '';
    }

    return mensaje;
  }

  async doAction(): Promise<void> {
    let mensajeLocal: string = this.validacionesLocales();
    if (mensajeLocal != '') {
      await this.toolsService.errorMensaje(mensajeLocal, true);
      return;
    }

    let spinnerRef = this.spinnerService.start();
    let mensajeValidacionServicio: string = await this.usuariosService.validarUsuarioService(this.local_data);

    if (mensajeValidacionServicio != '') {
      this.spinnerService.stop(spinnerRef);
      await this.toolsService.errorMensaje(mensajeValidacionServicio, true);
      return;
    }

    let resultado = await this.usuariosService.AddOrUpdateServiceNew(this.local_data);
    this.spinnerService.stop(spinnerRef);

    if (resultado.respuesta == 'ok'){
      if (resultado.advertencia == "") {
        let UsrInfo = this.authService.getUserInfo();
        if (this.local_data.run == UsrInfo.usuario.run) {
          await this.toolsService.okMensaje('Operación realizada con éxito, vuelva a iniciar sesión para refrescar los cambios');
        } else {
          await this.toolsService.okMensaje('Operación realizada con éxito');
        }
      } else {
        await this.toolsService.advertenciaMensaje('Operación realizada con advertencias!<br><br>' + resultado.advertencia,true);
      }
    } else {
      await this.toolsService.errorMensaje(resultado.respuesta,true);
    }

    this.dialogRef.close({ event: this.action, data: this.local_data });
  }

  closeDialog(): void {
    this.dialogRef.close({ event: 'Cancelar' });
  }

  onPerfilChange(obj: any) {
    this.local_data.perfiles.forEach((x: { predeterminado: boolean; }) => { x.predeterminado = false; });
    this.local_data.perfiles.filter((x: { idPerfil: any; }) => x.idPerfil === obj.value).forEach((z: { predeterminado: boolean; }) => { z.predeterminado = true; })
    this.local_data.idPerfil = obj.value;
    this.local_data.nombrePerfil = this.local_data.perfiles.filter((x: { idPerfil: any; }) => x.idPerfil === obj.value)[0].nombrePerfil;
  }

  async validarDatosUnidadesCargos() {
    if (this.local_data.comuna != '' && this.local_data.direccionRegional != '' && this.local_data.tipoUnidad != ''
      && this.local_data.comuna != undefined && this.local_data.direccionRegional != undefined && this.local_data.tipoUnidad != undefined) {

      let id: number = -1;
      if (this.local_data.tipoUnidad == 'OFICINA') {
        id = this.direccionesRegionales.filter((x) => x.nombreDireccionRegional == this.local_data.direccionRegional)[0].idDireccionRegional;
      } else {
        id = this.comunas.filter((x) => x.nombreComuna === this.local_data.comuna)[0].idComuna;
      }

      this.unidadGroups = await this.unidadesService.getListaUnidadesByTipoUnidad(this.local_data.tipoUnidad, id);
      this.cargoGroups = await this.unidadesService.getListaCargosByTipoUnidad(this.local_data.tipoUnidad, id);

      this.unidadGroupOptions = this.unidadForm.get('unidadGroup')!.valueChanges.pipe(startWith(''), map((valueU) => this._filterGroup(valueU ?? '')));
      this.cargoGroupOptions = this.cargoForm.get('cargoGroup')!.valueChanges.pipe(startWith(''), map((valueG) => this._filterCargoGroup(valueG ?? '')));

      this.unidadForm.enable();
      this.cargoForm.enable();

    } else {
      this.local_data.unidad = '';
      this.local_data.cargo = '';
      this.unidadGroups = [];
      this.cargoGroups = [];
      this.unidadForm.disable();
      this.cargoForm.disable();
    }
  }

  async onDireccionRegionalChange(obj: any) {
    if (obj.value != null) {

      let spinnerRef = this.spinnerService.start();

      this.local_data.direccionRegionalNumero = this.direccionesRegionales.filter((x) => x.nombreDireccionRegional == obj.value)[0].idDireccionRegional;
      this.comunas = this.comunasTodas.filter((x) => x.idRegion == this.local_data.direccionRegionalNumero);
      if (this.local_data.direccionRegionalNumero == 0) {
        this.local_data.region = 'REGIÓN METROPOLITANA';
        this.local_data.comuna = this.comunas[0].nombreComuna;
        this.local_data.tipoUnidad = 'OFICINA';
      } else {
        this.local_data.region = obj.value;
        this.local_data.comuna = '';
      }

      await this.validarDatosUnidadesCargos();

      this.spinnerService.stop(spinnerRef);
    }
  }

  async onComunaChange(obj: any) {
    if (obj.value != null) {

      let spinnerRef = this.spinnerService.start();

      this.local_data.comuna = obj.value;
      await this.validarDatosUnidadesCargos();

      this.spinnerService.stop(spinnerRef);
    }
  }

  async onTipoUnidadChange(obj: any) {
    if (obj.value != null) {
      let spinnerRef = this.spinnerService.start();

      this.local_data.tipoUnidad = obj.value;
      await this.validarDatosUnidadesCargos();
      
      this.spinnerService.stop(spinnerRef);
    }
  }

  validarLocalRutNuevoUsuario(event: any) {
    let mensaje: string = '';

    let rutBuscado: string = event.target.value;
    if (!rutBuscado.includes('-')) {
      mensaje += this.local_data.rundv + ' (xxxxxxxx-x) formato Rut inválido'
    } else {
      let dataRut: any = rutBuscado.split('-');
      this.local_data.run = dataRut[0];
      this.local_data.dv = dataRut[1];

      let digito: string = Utils.calcularVerificador(this.local_data.run);
      if (digito != this.local_data.dv) {
        mensaje += this.local_data.rundv + ' Rut inválido'
      }
    }
    
    return mensaje;
  }

  async validarServicioRutNuevoUsuario(rut: any) {
    let mensaje: string = '';

    let spinnerRef = this.spinnerService.start();

    let usuB: any = await this.usuariosService.getUsuariosByRutService(rut);
    let UsrInfo = this.authService.getUserInfo();

    this.spinnerService.stop(spinnerRef);

    if (usuB.respuesta != 'ok') {
      return { mensaje, usuB };
    }

    if (!UsrInfo.usuario.usarDatosNacionales) {
      if (usuB.usuario.direccionRegionalNumero != -1 && (usuB.usuario.direccionRegionalNumero != UsrInfo.usuario.direccionRegionalNumero)) {
        mensaje += 'El usuario que intenta ingresar o modificar pertenese a otra región, favor comuniquese con MDA de la ' + usuB.usuario.direccionRegional + ' para regularizar el cambio!';
      }
    }

    return { mensaje, usuB };
  }

  async onFocusOutRutEvent(event: any) {

    if (event.target.value == null || event.target.value == '' || event.target.value == undefined) {
      return;
    }

    let mensajeRut: string = this.validarLocalRutNuevoUsuario(event);

    if (mensajeRut != '') {
      await this.toolsService.errorMensaje(mensajeRut);
      this.limpiarDialog();
      return;
    }

    let rutBuscado: string = event.target.value;
    let res = await this.validarServicioRutNuevoUsuario(rutBuscado)
    mensajeRut = res.mensaje;   

    if (mensajeRut != '') {
      await this.toolsService.errorMensaje(mensajeRut);
      this.limpiarDialog();
      return;
    }

    if (res.usuB.advertencia.toString() != '') {
      if (this.toolsService.userInRol(['ADMINISTRADOR','ADMINISTRADOR MDA NACIONAL'])) {
        let respuestaM = await this.toolsService.confirmaMensaje('Atención',res.usuB.advertencia + '<br>¿Desea continuar?',true);
        if (!respuestaM) {
          this.limpiarDialog();         
        }
      } else {
        await this.toolsService.errorMensaje('Atención<br>' + res.usuB.advertencia + '<br>contacte al administrador del sistema.', true);
        this.limpiarDialog();      
      }
      return;
    }

    let spinnerRef = this.spinnerService.start();

    let usuarioBuscado: UsuarioData = res.usuB.usuario;
    
    if (usuarioBuscado.idUsuario != '') {
      this.action = 'Actualizar';
      
    }

    if (usuarioBuscado.direccionRegional != '') {
      let regSel: number = this.direccionesRegionales.filter((x) => x.nombreDireccionRegional === usuarioBuscado.direccionRegional)[0].idDireccionRegional;
      this.comunas = this.comunasTodas.filter((x) => x.idRegion == regSel);
    }

    this.local_data = usuarioBuscado;

    await this.validarDatosUnidadesCargos();
    
    this.spinnerService.stop(spinnerRef);
  }

  limpiarDialog() {
    this.local_data = [];
  }

  async ngOnInit() {
    let spinnerRef = this.spinnerService.start();

    this.direccionesRegionales = await this.regioncomunaService.getDireccionesRegionalesService();
    this.comunasTodas = await this.regioncomunaService.getComunasService();

    this.comunas = this.comunasTodas;
    this.perfiles = await this.perfilesService.getPerfilesService();

    await this.validarDatosUnidadesCargos();

    this.spinnerService.stop(spinnerRef);
  }

  private _filterGroup(value: string): UnidadGroup[] {
    if (value) {
      return this.unidadGroups
        .map((group) => ({
          letraUnidad: group.letraUnidad,
          nombresUnidad: _filter(group.nombresUnidad, value),
        }))
        .filter((group) => group.nombresUnidad.length > 0);
    }

    return this.unidadGroups;
  }

  private _filterCargoGroup(value: string): CargoGroup[] {
    if (value) {
      return this.cargoGroups
        .map((groupC) => ({
          letraCargo: groupC.letraCargo,
          nombresCargo: _filter(groupC.nombresCargo, value),
        }))
        .filter((groupC) => groupC.nombresCargo.length > 0);
    }

    return this.cargoGroups;
  }
}